export const getKeyValue: <T extends object>(
  obj: T,
  key: keyof T,
) => T[keyof T] = (obj, key) => obj[key];

type AscOrDesc = "asc" | "desc";

const aLowerBLowerValue: (
  ascOrDesc: AscOrDesc | undefined,
) => [1 | -1, 1 | -1] = (ascOrDesc) => {
  const aIsLowerValue = ascOrDesc === "desc" ? 1 : -1;
  const bIsLowerValue = ascOrDesc === "desc" ? -1 : 1;
  return [aIsLowerValue, bIsLowerValue];
};

export const sortBy: <T extends object>(
  data: ReadonlyArray<T>,
  key: keyof T,
  ascOrDesc: AscOrDesc | undefined,
) => ReadonlyArray<T> = (data, key, ascOrDesc = "asc") =>
  orderBy(data, [key], [ascOrDesc]);

export const orderBy: <T extends object>(
  data: ReadonlyArray<T>,
  keys: (keyof T)[],
  ascOrDescs: AscOrDesc[] | undefined,
) => ReadonlyArray<T> = (data, keys, ascOrDescs = []) => {
  if (keys.length === 0) {
    return data;
  }
  const shallowCopy = [...data];
  return shallowCopy.sort((a, b) => {
    for (const [index, key] of keys.entries()) {
      const aValue = getKeyValue(a, key);
      const bValue = getKeyValue(b, key);
      const [aIsLowerValue, bIsLowerValue] = aLowerBLowerValue(
        ascOrDescs[index],
      );
      if (aValue < bValue) {
        return aIsLowerValue;
      }
      if (aValue > bValue) {
        return bIsLowerValue;
      }
    }
    return 0;
  });
};
